import { render, staticRenderFns } from "./SupervisorsAssignation.vue?vue&type=template&id=3e56ae60&"
import script from "./SupervisorsAssignation.vue?vue&type=script&lang=js&"
export * from "./SupervisorsAssignation.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorsAssignation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports